import axios from 'axios'
import store from '../store'

import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
// Dashboard pages
import Overview from 'src/components/Dashboard/Views/Dashboard/Overview.vue'
import Stats from 'src/components/Dashboard/Views/Dashboard/Stats.vue'

// Pages
import User from 'src/components/Dashboard/Views/Pages/UserProfile.vue'
import TimeLine from 'src/components/Dashboard/Views/Pages/TimeLinePage.vue'
import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue'

// Components pages
import Buttons from 'src/components/Dashboard/Views/Components/Buttons.vue'
import GridSystem from 'src/components/Dashboard/Views/Components/GridSystem.vue'
import Panels from 'src/components/Dashboard/Views/Components/Panels.vue'
import SweetAlert from 'src/components/Dashboard/Views/Components/SweetAlert.vue'
import Notifications from 'src/components/Dashboard/Views/Components/Notifications.vue'
import Icons from 'src/components/Dashboard/Views/Components/Icons.vue'
import Typography from 'src/components/Dashboard/Views/Components/Typography.vue'

// Forms pages
import RegularForms from 'src/components/Dashboard/Views/Forms/RegularForms.vue'
import ExtendedForms from 'src/components/Dashboard/Views/Forms/ExtendedForms.vue'
import ValidationForms from 'src/components/Dashboard/Views/Forms/ValidationForms.vue'

// TableList pages
import RegularTables from 'src/components/Dashboard/Views/Tables/RegularTables.vue'
import ExtendedTables from 'src/components/Dashboard/Views/Tables/ExtendedTables.vue'
import PaginatedTables from 'src/components/Dashboard/Views/Tables/PaginatedTables.vue'
// Maps pages
import GoogleMaps from 'src/components/Dashboard/Views/Maps/GoogleMaps.vue'
import FullScreenMap from 'src/components/Dashboard/Views/Maps/FullScreenMap.vue'
import VectorMaps from 'src/components/Dashboard/Views/Maps/VectorMapsPage.vue'

// // Calendar
// import Calendar from 'src/components/Dashboard/Views/Calendar/CalendarRoute.vue'
// // Charts
// import Charts from 'src/components/Dashboard/Views/Charts.vue'
// // Patients

import RegistrationSinglePage from 'src/components/Dashboard/Views/Patient/SinglePage/Register.vue'

import RegistrationWizard from 'src/components/Dashboard/Views/Patient/RegistrationWizard'
import ResultsWizard from 'src/components/Dashboard/Views/Results/ResultsWizard'
import PaymentWizard from 'src/components/Dashboard/Views/Patient/PaymentWizard'
import Home from 'src/components/Dashboard/Views/Home'
import RegistrationKitWizard from 'src/components/Dashboard/Views/RegistrationKit/RegistrationKitWizard'
// import SignUpWizard from 'src/components/Dashboard/Views/Account/SignUp/SignUpWizard'
// import LoginWizard from 'src/components/Dashboard/Views/Account/Login/LoginWizard'
// import PasswordResetWizard from 'src/components/Dashboard/Views/Account/PasswordReset/PasswordResetWizard'

import SiteSelectionStep from 'src/components/Dashboard/Views/Patient/Wizard/SiteSelectionStep'
import DisclaimerStep from 'src/components/Dashboard/Views/Patient/Wizard/DisclaimerStep'
import ConsentStep from 'src/components/Dashboard/Views/Patient/Wizard/ConsentStep'
import MedicationDataStep from 'src/components/Dashboard/Views/Patient/Wizard/MedicationDataStep'
import InsuranceStep from 'src/components/Dashboard/Views/Utils/Sections/BillSection'
import SubmissionStep from 'src/components/Dashboard/Views/Patient/Wizard/SubmissionStep'
import PaymentStep from 'src/components/Dashboard/Views/Patient/Wizard/PaymentStep'
import Card from 'src/components/Dashboard/Views/Utils/SubComponents/PaymentParts/paymentOrderStripe'

import SiteSelectionStepResults from 'src/components/Dashboard/Views/RegistrationKit/Wizard/SiteSelectionStepKit'
import KitPatientData from 'src/components/Dashboard/Views/RegistrationKit/Wizard/Data'
import KitPatientDisclaimer from 'src/components/Dashboard/Views/RegistrationKit/Wizard/Disclaimer'
import ScanKit from 'src/components/Dashboard/Views/RegistrationKit/Wizard/ScanKit'

import SiteSelectionStepKit from 'src/components/Dashboard/Views/Results/Wizard/SiteSelectionStep'
import Data from 'src/components/Dashboard/Views/Results/Wizard/Data'
import DisclaimerStepResults from 'src/components/Dashboard/Views/Results/Wizard/DisclaimerStep'
import ConsentStepResults from 'src/components/Dashboard/Views/Results/Wizard/ConsentStep'
import ChooseMethod from 'src/components/Dashboard/Views/Results/Wizard/ChooseMethod'
import CheckConfirmationNumber from 'src/components/Dashboard/Views/Results/Wizard/CheckConfirmationNumber'
import Result from 'src/components/Dashboard/Views/Results/Wizard/Result'
import ResultQR from 'src/components/Dashboard/Views/Results/Wizard/ResultQR'

import ResultsPanel from 'src/components/Dashboard/Views/Account/Dashboard/ResultsPanel'
import PersonalData from 'src/components/Dashboard/Views/Account/Dashboard/PersonalData'
import AccountDashboard from 'src/components/Dashboard/Views/Account/Dashboard/Dashboard'
import SmallDashboard from 'src/components/Dashboard/Views/Account/Dashboard/SmallDashboard'
import AccountDependents from 'src/components/Dashboard/Views/Account/Dashboard/Dependents'
import FormRegistration from 'src/components/Dashboard/Views/Account/Dashboard/Registration'
import AccountManagement from 'src/components/Dashboard/Views/Account/Dashboard/ManageAccount'

import OrderConfirmation from 'src/components/Dashboard/Views/Patient/OrderConfirmation'

import GoPass from 'src/components/Dashboard/Views/GoPass/GoPassLayout.vue'
import GoPassAccount from 'src/components/Dashboard/Views/Account/Dashboard/GoPassLogged.vue'
import PayMyBillsAccount from 'src/components/Dashboard/Views/Account/Dashboard/PayMyBillsLogged.vue'

import SelfOrdering from 'src/components/Dashboard/Views/SelfOrdering/SelfOrderingLayout.vue'
import ScheduleSection from '../components/Dashboard/Views/Utils/Sections/ScheduleSection'
import AccountSchedule from '../components/Dashboard/Views/Account/Dashboard/Schedule'
import TemplateTesting from '../../src/components/GeneralViews/TemplateTesting.vue'

let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  children: [
    {
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'panels',
      name: 'Panels',
      component: Panels
    },
    {
      path: 'sweet-alert',
      name: 'Sweet Alert',
      component: SweetAlert
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }

  ]
}

let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Forms',
      component: RegularForms
    },
    {
      path: 'extended',
      name: 'Extended Forms',
      component: ExtendedForms
    },
    {
      path: 'validation',
      name: 'Validation Forms',
      component: ValidationForms
    }
    // {
    //   path: 'wizard',
    //   name: 'RegistrationWizard',
    //   component: RegistrationWizard
    // }
  ]
}

let tablesMenu = {
  path: '/table-list',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Tables',
      component: RegularTables
    },
    {
      path: 'extended',
      name: 'Extended Tables',
      component: ExtendedTables
    },
    {
      path: 'paginated',
      name: 'Paginated Tables',
      component: PaginatedTables
    }]
}

let mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  redirect: '/maps/google',
  children: [
    {
      path: 'google',
      name: 'Google Maps',
      component: GoogleMaps
    },
    {
      path: 'full-screen',
      name: 'Full Screen Map',
      component: FullScreenMap
    },
    {
      path: 'vector-map',
      name: 'Vector Map',
      component: VectorMaps
    }
  ]
}

let pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  redirect: '/pages/user',
  children: [
    {
      path: 'user',
      name: 'User Page',
      component: User
    },
    {
      path: 'timeline',
      name: 'Timeline Page',
      component: TimeLine
    }
  ]
}

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}

let patientRegistration = null
patientRegistration = {
  beforeEnter: (to, from, next) => {
    if (localStorage.getItem('token')) {
      next({path: '/patient/account/form/registration'})
    } else {
      let configs = null
      axios.get(process.env.SERVER_URI + '/configs')
      .then(async (response) => {
        store.state.configs = response.data
        store.state.dl_or_ssn_required_by_client = store.state.configs.DL_OR_SSN_REQUIRED_BY_CLIENT
        store.state.allow_dl_or_ssn = store.state.configs.ALLOW_DL_OR_SSN
        configs = response.data
        if (configs['ALLOW_REGISTRATION'] === true) {
          if (to.path === '/patient/register' && store.state.configs.SINGLE_PAGE_ORDERS === true) {
            next({path: '/patient/order'})
          } else if (from.path === '/patient/order' && store.state.configs.SINGLE_PAGE_ORDERS === true) {
            next({path: '/patient/order'})
          } else {
            next()
          }
        } else {
          next({ path: '/error?error=registration&page=' + from.path, component: NotFound })
        }
      })
    }
  },
  path: '/patient/register',
  component: DashboardLayout,
  children: [{
    path: '/patient/register',
    name: 'RegistrationWizard',
    component: RegistrationWizard,
    children: [{
      path: '/patient/register/site-selection',
      component: SiteSelectionStep
    },
    {
      path: '/patient/register/disclaimer',
      name: 'DisclaimerStep',
      component: DisclaimerStep
    },
    {
      path: '/patient/register/medical-data',
      name: 'MedicationDataStep',
      component: MedicationDataStep
    },
    {
      path: '/patient/register/consent',
      name: 'ConsentStep',
      component: ConsentStep
    },
    {
      path: '/patient/register/insurance',
      name: 'InsuranceStep',
      component: InsuranceStep
    },
    {
      path: '/patient/register/telehealth',
      name: 'SubmissionStep',
      component: SubmissionStep
    },
    {
      path: '/patient/register/payment/process',
      name: 'PaymentStep',
      component: PaymentStep
    },
    {
      path: '/patient/register/appointment',
      name: 'AppointmentStep',
      component: ScheduleSection
    }]
  }, {
    path: '/patient/order',
    name: 'RegistrationSinglePage',
    component: RegistrationSinglePage
  }, {
    path: '/patient/order/confirmation/:site_code/:confirmation_number/:first_name/:last_name',
    name: 'OrderConfirmation',
    component: OrderConfirmation
  }
  ]
}

let patientRegistrationHomeCollection = null
patientRegistrationHomeCollection = {
  beforeEnter: (to, from, next) => {
    if (localStorage.getItem('token')) {
      next({path: '/patient/account/form/registration'})
    } else {
      let configs = null
      axios.get(process.env.SERVER_URI + '/configs')
      .then(async (response) => {
        store.state.configs = response.data
        store.state.dl_or_ssn_required_by_client = store.state.configs.DL_OR_SSN_REQUIRED_BY_CLIENT
        store.state.allow_dl_or_ssn = store.state.configs.ALLOW_DL_OR_SSN
        configs = response.data
        if (configs['ALLOW_REGISTRATION'] === true) {
          if (to.path === '/patient/register-home-collection' && store.state.configs.SINGLE_PAGE_ORDERS === true) {
            next({path: '/patient/order-home-collection'})
          } else if (from.path === '/patient/order-home-collection' && store.state.configs.SINGLE_PAGE_ORDERS === true) {
            next({path: '/patient/order-home-collection'})
          } else {
            next()
          }
        } else {
          next({ path: '/error?error=registration&page=' + from.path, component: NotFound })
        }
      })
    }
  },
  path: '/patient/register-home-collection',
  component: DashboardLayout,
  children: [{
    path: '/patient/register-home-collection',
    name: 'RegistrationWizard',
    component: RegistrationWizard,
    children: [{
      path: '/patient/register-home-collection/site-selection',
      component: SiteSelectionStep
    },
    {
      path: '/patient/register-home-collection/disclaimer',
      name: 'DisclaimerStep',
      component: DisclaimerStep
    },
    {
      path: '/patient/register-home-collection/medical-data',
      name: 'MedicationDataStep',
      component: MedicationDataStep
    },
    {
      path: '/patient/register-home-collection/consent',
      name: 'ConsentStep',
      component: ConsentStep
    },
    {
      path: '/patient/register-home-collection/insurance',
      name: 'InsuranceStep',
      component: InsuranceStep
    },
    {
      path: '/patient/register-home-collection/appointment',
      name: 'AppointmentStep',
      component: ScheduleSection
    },
    {
      path: '/patient/register/telehealth',
      name: 'SubmissionStep',
      component: SubmissionStep
    },
    {
      path: '/patient/register-home-collection/payment/process',
      name: 'PaymentStep',
      component: PaymentStep
    },
    {
      path: '/patient/register/appointment',
      name: 'AppointmentStep',
      component: ScheduleSection
    }]
  }, {
    path: '/patient/order-home-collection',
    name: 'RegistrationSinglePage',
    component: RegistrationSinglePage
  }, {
    path: '/patient/order-home-collection/confirmation/:site_code/:confirmation_number/:first_name/:last_name',
    name: 'OrderConfirmation',
    component: OrderConfirmation
  }
  ]
}

let checkResults = null
checkResults = {
  beforeEnter: (to, from, next) => {
    if (localStorage.getItem('token')) {
      next({path: '/patient/account/results'})
    } else {
      let configs = null
      axios.get(process.env.SERVER_URI + '/configs')
      .then(async (response) => {
        store.state.configs = response.data
        store.state.dl_or_ssn_required_by_client = store.state.configs.DL_OR_SSN_REQUIRED_BY_CLIENT
        store.state.allow_dl_or_ssn = store.state.configs.ALLOW_DL_OR_SSN
        configs = response.data
        if (configs['ALLOW_RESULTS'] === true) {
          next(true)
        } else {
          next({ path: '/error?error=results&page=' + from.path, component: NotFound })
        }
      })
    }
  },
  path: '/patient/check-results',
  component: DashboardLayout,
  children: [{
    path: '/patient/check-results',
    name: 'ResultsWizard',
    component: ResultsWizard,
    children: [{
      path: '/patient/check-results/site',
      component: SiteSelectionStepResults
    },
    {
      path: '/patient/check-results/medical-data',
      name: 'Data',
      component: Data
    },
    {
      path: '/patient/check-results/disclaimer',
      name: 'DisclaimerStepResults',
      component: DisclaimerStepResults
    },
    {
      path: '/patient/check-results/consent',
      name: 'ConsentStepResults',
      component: ConsentStepResults
    },
    {
      path: '/patient/check-results/send-method',
      name: 'ChooseMethod',
      component: ChooseMethod
    },
    {
      path: '/patient/check-results/validation',
      name: 'CheckConfirmationNumber',
      component: CheckConfirmationNumber
    },
    {
      path: '/patient/check-results/results',
      name: 'Result',
      component: Result
    }]
  }
  ]
}

let QRToResults = null
QRToResults = {
  async beforeEnter (to, from, next) {
    await axios.get(process.env.SERVER_URI + '/configs')
    .then(async (response) => {
      store.state.configs = response.data
      store.state.dl_or_ssn_required_by_client = store.state.configs.DL_OR_SSN_REQUIRED_BY_CLIENT
      store.state.allow_dl_or_ssn = store.state.configs.ALLOW_DL_OR_SSN
    })
    if (store.state.configs['ALLOW_RESULTS'] === true) {
      axios.get(process.env.SERVER_URI + '/get/validatedResults/' + to.params['site_code'] + '/' + to.params['confirmation_number'] + '/' + to.params['first_name'] + '/' + to.params['last_name'] + '/' + to.params['guid'])
      .then(async (response) => {
        store.state.results.user.result = response.data
        next(true)
      })
    } else {
      next({ path: '/error?error=results&page=' + from.path, component: NotFound })
    }
  },
  path: '/patient/get-results/:site_code/:confirmation_number/:first_name/:last_name/:guid',
  name: 'ResultsQR',
  component: DashboardLayout,
  children: [{
    path: '/patient/get-results/:site_code/:confirmation_number/:first_name/:last_name/:guid',
    name: 'ResultsQRWizard',
    component: ResultQR
  }
  ]
}

let GoPassRoute = null
GoPassRoute = {
  async beforeEnter (to, from, next) {
    await axios.get(process.env.SERVER_URI + '/configs')
      .then(async (response) => {
        store.state.configs = response.data
        store.state.dl_or_ssn_required_by_client = store.state.configs.DL_OR_SSN_REQUIRED_BY_CLIENT
        store.state.allow_dl_or_ssn = store.state.configs.ALLOW_DL_OR_SSN
      })
    if (store.state.configs['ALLOW_GO_PASS'] === true) {
      next(true)
    } else {
      next({ path: '/error?error=go_pass&page=' + from.path, component: NotFound })
    }
  },
  path: '/go-pass',
  name: 'GoPassLayout',
  component: DashboardLayout,
  children: [{
    path: '/go-pass',
    name: 'GoPass',
    component: GoPass
  }]
}

let SelfOrderingRoute = null
SelfOrderingRoute = {
  async beforeEnter (to, from, next) {
    await axios.get(process.env.SERVER_URI + '/configs')
      .then(async (response) => {
        store.state.configs = response.data
        store.state.dl_or_ssn_required_by_client = store.state.configs.DL_OR_SSN_REQUIRED_BY_CLIENT
        store.state.allow_dl_or_ssn = store.state.configs.ALLOW_DL_OR_SSN
      })
    if (store.state.configs['ALLOW_SELF_ORDERING'] === true) {
      next(true)
    } else {
      next({ path: '/error?error=quick_order&page=' + from.path, component: NotFound })
    }
  },
  path: '/self-order',
  name: 'SelfOrderingLayout',
  component: DashboardLayout,
  children: [{
    path: '/self-order',
    name: 'SelfOrdering',
    component: SelfOrdering
  }]
}

let payment = null
payment = {
  beforeEnter: (to, from, next) => {
    let configs = null
    axios.get(process.env.SERVER_URI + '/configs')
    .then(async (response) => {
      store.state.configs = response.data
      configs = response.data
      store.state.dl_or_ssn_required_by_client = store.state.configs.DL_OR_SSN_REQUIRED_BY_CLIENT
      store.state.allow_dl_or_ssn = store.state.configs.ALLOW_DL_OR_SSN
      if (configs['ALLOW_PAYMENT'] === true) {
        next()
      } else {
        next({ path: '/error?error=payment&page=' + from.path, component: NotFound })
      }
    })
  },
  path: '/patient/payment/:id',
  component: DashboardLayout,
  children: [{
    path: '/patient/payment/:id',
    name: 'PaymentWizard',
    component: PaymentWizard,
    children: [{
      path: '/patient/payment/:id',
      component: Card
    }]
  }]
}

let kitRegistration = null
kitRegistration = {
  beforeEnter: (to, from, next) => {
    let configs = null
    axios.get(process.env.SERVER_URI + '/configs')
    .then(async (response) => {
      store.state.configs = response.data
      store.state.dl_or_ssn_required_by_client = store.state.configs.DL_OR_SSN_REQUIRED_BY_CLIENT
      store.state.allow_dl_or_ssn = store.state.configs.ALLOW_DL_OR_SSN
      configs = response.data
      if (configs['ALLOW_KIT_REGISTRATION'] === true) {
        next()
      } else {
        next({ path: '/error?error=kit_registration&page=' + from.path, component: NotFound })
      }
    })
  },
  path: '/patient/kit',
  component: DashboardLayout,
  children: [{
    path: '/patient/kit',
    name: 'KitWizard',
    component: RegistrationKitWizard,
    children: [{
      path: '/patient/kit/site',
      component: SiteSelectionStepKit
    },
    {
      path: '/patient/kit/disclaimer',
      name: 'KitPatientDisclaimer',
      component: KitPatientDisclaimer
    },
    {
      path: '/patient/kit/medical-data',
      name: 'KitPatientData',
      component: KitPatientData
    },
    {
      path: '/patient/kit/scan',
      name: 'ScanKit',
      component: ScanKit
    }]
  }]
}

let accountRoute = null
accountRoute = {
  beforeEnter: (to, from, next) => {
    let one = process.env.SERVER_URI + '/configs'
    axios.get(one).then(response => {
      if (response.data) {
        store.state.configs = response.data
        store.state.dl_or_ssn_required_by_client = store.state.configs.DL_OR_SSN_REQUIRED_BY_CLIENT
        store.state.allow_dl_or_ssn = store.state.configs.ALLOW_DL_OR_SSN

        if (store.state.configs.DISPLAY_REQUISITION_SCHEDULING_ACCOUNT === undefined) {
          store.state.configs.DISPLAY_REQUISITION_SCHEDULING_ACCOUNT = true
        }

        if (store.state.configs.DISPLAY_NEW_ORDER_ACCOUNT === undefined) {
          store.state.configs.DISPLAY_NEW_ORDER_ACCOUNT = true
        }
        if (store.state.configs.DISPLAY_KIT_ACCOUNT === undefined) {
          store.state.configs.DISPLAY_KIT_ACCOUNT = true
        }
        if (store.state.configs.DISPLAY_RESULTS_ACCOUNT === undefined) {
          store.state.configs.DISPLAY_RESULTS_ACCOUNT = true
        }
        if (store.state.configs.DISPLAY_DEPENDENTS_ACCOUNT === undefined) {
          store.state.configs.DISPLAY_DEPENDENTS_ACCOUNT = true
        }
        if (store.state.configs.DISPLAY_GO_PASS_ACCOUNT === undefined) {
          store.state.configs.DISPLAY_GO_PASS_ACCOUNT = true
        }

        store.state.dashboardElements = []

        // if ALLOW_REGISTRATION = true -> column Orders and Dependents will appear
        if (store.state.configs.ALLOW_REGISTRATION === true && store.state.configs.DISPLAY_NEW_ORDER_ACCOUNT === true) {
          store.state.dashboardElements.push('newOrder')
        }
        if (store.state.configs.ALLOW_KIT_REGISTRATION === true && store.state.configs.DISPLAY_KIT_ACCOUNT === true) {
          store.state.dashboardElements.push('registerKit')
        }
        if (store.state.configs.ALLOW_RESULTS === true && store.state.configs.DISPLAY_RESULTS_ACCOUNT === true) {
          store.state.dashboardElements.push('results')
        }
        if (store.state.configs.ALLOW_GO_PASS === true && store.state.configs.DISPLAY_GO_PASS_ACCOUNT === true) {
          store.state.dashboardElements.push('goPass')
        }
        if (store.state.configs.PAY_MY_BILLS === true && store.state.configs.DISPLAY_PAY_MY_BILLS === true) {
          store.state.dashboardElements.push('payMyBills')
        }
        if (store.state.configs.REQUISITION_SCHEDULING === true && store.state.configs.DISPLAY_REQUISITION_SCHEDULING_ACCOUNT === true) {
          store.state.dashboardElements.push('schedule')
        }

        if (store.state.configs['ALLOW_ACCOUNTS'] === false) {
          localStorage.removeItem('token')
          localStorage.removeItem('email')
          store.state.accountsAllowed = false
          next({path: '/'})
        } else {
          store.state.accountsAllowed = true
          let two = process.env.SERVER_URI + '/account/check/sitecode'
          let three = process.env.SERVER_URI + '/account/check/user'
          let email = localStorage.getItem('email')
          const requestTwo = axios.post(two, {'email': email}, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          })
          const requestThree = axios.post(three, {'email': email}, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          })
          let firstRegistration = false
          axios.all([requestTwo, requestThree])
            .then(axios.spread((...responses) => {
              if (store.state.accountsAllowed) {
                if (store.state.skip) {
                  next(true)
                } else {
                  store.state.sitecode = responses[0].data.code || false
                  store.state.firstRegistration = firstRegistration = responses[0].data['first_registration'] || false
                  if (responses[1].data) {
                    store.state.firedesk40583_2 = responses[1].data.addressComponents // stefan - 04/02/2025 - keep all lines that contain "firedesk40583"
                    if (responses[1].data['first_name']) {
                      localStorage.setItem('firstName', responses[1].data['first_name'])
                    }
                    if (responses[1].data['last_name']) {
                      localStorage.setItem('lastName', responses[1].data['last_name'])
                    }
                  }
                  store.state.clientLoggedKey += 1
                  const skipFirst = store.state.configs.SKIP_FIRST_REGISTRATION === true && store.state.configs.SKIP_FIRST_REGISTRATION !== undefined
                  if ((store.state.sitecode === false || firstRegistration) && !skipFirst) {
                    store.state.skip = true
                    next({path: '/patient/account/data'})
                  } else {
                    store.state.skip = false
                    next(true)
                  }
                }
              } else {
                localStorage.removeItem('token')
                localStorage.removeItem('email')
                store.state.accountsAllowed = false
                next({path: '/'})
              }
            })).catch(error => {
              console.log(error)
            })
        }
      }
    })
  },
  path: '/patient/account',
  component: DashboardLayout,
  children: [{
    path: '/patient/account/results',
    name: 'AccountResultsPanel',
    component: ResultsPanel
  },
  {
    path: '/patient/account/form/registration',
    name: 'AccountFormRegistration',
    component: FormRegistration
  },
  {
    path: '/patient/account/manage',
    name: 'AccountManagementPanel',
    component: AccountManagement
  },
  {
    path: '/patient/account/dependents',
    name: 'AccountDependents',
    component: AccountDependents
  },
  {
    path: '/patient/account/data',
    name: 'AccountPersonalData',
    component: PersonalData
  },
  {
    path: '',
    name: 'AccountDashboard',
    component: AccountDashboard
  },
  {
    path: '/patient/account/go-pass',
    name: 'AccountGoPass',
    component: GoPassAccount
  },
  {
    path: '/patient/account/configuration',
    name: 'SmallDashboard',
    component: SmallDashboard
  },
  {
    path: '/patient/account/pay-my-bills',
    name: 'AccountPayMyBills',
    component: PayMyBillsAccount
  },
  {
    path: '/patient/account/schedule',
    name: 'AccountSchedule',
    component: AccountSchedule
  }]
}

let lockPage = {
  path: '/lock',
  name: 'Lock',
  component: Lock
}

let templateTestingRoute = null
templateTestingRoute = {
  path: '/template-testing',
  name: 'Testing',
  component: TemplateTesting
}

let routes = []
if (process.env.NODE_ENV === 'production') {
  routes = [
    {
      beforeEnter: (to, from, next) => {
        axios.get(process.env.SERVER_URI + '/configs')
        .then(async (response) => {
          store.state.configs = response.data
          store.state.dl_or_ssn_required_by_client = store.state.configs.DL_OR_SSN_REQUIRED_BY_CLIENT
          store.state.allow_dl_or_ssn = store.state.configs.ALLOW_DL_OR_SSN
          next()
        })
      },
      path: '/',
      component: Home
    }
  ]
  if (patientRegistration) {
    routes.push(patientRegistration)
  }
  if (patientRegistrationHomeCollection) {
    routes.push(patientRegistrationHomeCollection)
  }
  if (checkResults) {
    routes.push(checkResults)
  }
  if (QRToResults) {
    routes.push(QRToResults)
  }
  if (GoPassRoute) {
    routes.push(GoPassRoute)
  }
  if (SelfOrderingRoute) {
    routes.push(SelfOrderingRoute)
  }
  if (payment) {
    routes.push(payment)
  }
  if (kitRegistration) {
    routes.push(kitRegistration)
  }
  if (accountRoute) {
    routes.push(accountRoute)
  }
  if (templateTestingRoute) {
    routes.push(templateTestingRoute)
  }
  routes.push({ path: '*', component: NotFound })
} else {
  routes = [
    {
      beforeEnter: (to, from, next) => {
        axios.get(process.env.SERVER_URI + '/configs')
        .then(async (response) => {
          store.state.configs = response.data
          store.state.dl_or_ssn_required_by_client = store.state.configs.DL_OR_SSN_REQUIRED_BY_CLIENT
          store.state.allow_dl_or_ssn = store.state.configs.ALLOW_DL_OR_SSN
          next()
        })
      },
      path: '/',
      component: Home
    },
    componentsMenu,
    formsMenu,
    tablesMenu,
    mapsMenu,
    pagesMenu,
    loginPage,
    lockPage,
    {
      path: '/admin',
      component: DashboardLayout,
      redirect: '/admin/overview',
      children: [
        {
          path: 'overview',
          name: 'Overview',
          component: Overview
        },
        {
          path: 'stats',
          name: 'Stats',
          component: Stats
        }
      ]
    }
  ]
  if (patientRegistration) {
    routes.push(patientRegistration)
  }
  if (patientRegistrationHomeCollection) {
    routes.push(patientRegistrationHomeCollection)
  }
  if (checkResults) {
    routes.push(checkResults)
  }
  if (QRToResults) {
    routes.push(QRToResults)
  }
  if (GoPassRoute) {
    routes.push(GoPassRoute)
  }
  if (SelfOrderingRoute) {
    routes.push(SelfOrderingRoute)
  }
  if (payment) {
    routes.push(payment)
  }
  if (kitRegistration) {
    routes.push(kitRegistration)
  }
  if (accountRoute) {
    routes.push(accountRoute)
  }
  if (templateTestingRoute) {
    routes.push(templateTestingRoute)
  }
  routes.push({ path: '*', component: NotFound })
}
/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js